import React from 'react';

const SubscriptionContext = React.createContext({
    id: null,
    data: null,
});

SubscriptionContext.create = (id, data) => ({
    id,
    data,
});

const withSubscriptionContext = Component => {
    return function WrapperComponentContext(props) {
        return (
            <SubscriptionContext.Consumer>
                {subscription => (
                    <Component {...props} subscription={subscription} />
                )}
            </SubscriptionContext.Consumer>
        );
    };
};

export { SubscriptionContext, withSubscriptionContext };
